import { z } from "zod";
import i18n from "@/i18n";

const t = (key: string) => i18n.t(`monitoring.${key}`);

export const createServerSchema = () =>
  z.object({
    name: z.string().min(1, { message: t("validation.nameRequired") }),
    url: z
      .string()
      .min(1, { message: t("validation.urlRequired") })
      .regex(/^https?:\/\/.+/, { message: t("validation.urlInvalid") }),
    token: z.string().min(1, { message: t("validation.tokenRequired") }),
    metricRateSeconds: z
      .number()
      .min(1, { message: t("validation.rateMin") })
      .optional(),
    metricHistoryDays: z
      .number()
      .min(1, { message: t("validation.historyMin") })
      .optional(),
    pushIntervalSeconds: z
      .number()
      .min(1, { message: t("validation.intervalMin") })
      .optional(),
  });

export const updateServerSchema = () =>
  z.object({
    name: z.string().min(1, { message: t("validation.nameRequired") }),
    url: z
      .string()
      .min(1, { message: t("validation.urlRequired") })
      .regex(/^https?:\/\/.+/, { message: t("validation.urlInvalid") }),
    token: z.string().optional(),
    metricRateSeconds: z
      .number()
      .min(1, { message: t("validation.rateMin") })
      .optional(),
    metricHistoryDays: z
      .number()
      .min(1, { message: t("validation.historyMin") })
      .optional(),
    pushIntervalSeconds: z
      .number()
      .min(1, { message: t("validation.intervalMin") })
      .optional(),
  });

export type CreateServerFormData = z.input<
  ReturnType<typeof createServerSchema>
>;
export type UpdateServerFormData = z.input<
  ReturnType<typeof updateServerSchema>
>;
